var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('v-card',{staticStyle:{"background":"#f2f2f2"},attrs:{"flat":"","height":"650px"}}),_c('app-nav'),_c('about-me'),_c('experience'),_c('tijuana-parallax'),_c('works')],1)}
var staticRenderFns = []

export { render, staticRenderFns }